import React, {useEffect, useRef, useState} from 'react';
import {Card}                               from 'primereact/card';
import {Image}                              from 'primereact/image';
import {useNavigate}                        from "react-router-dom";
import {Toast}                              from "primereact/toast";
import {InputText}                          from "primereact/inputtext";
import {Button}                             from "primereact/button";

import {FundoLogin}            from './style';
import Logo                    from '../../assets/LogoLogin.png';
import useMobile               from "../../hooks/useMobile";
import {RegistrarToken, Token} from "../../services/auth";
import api                     from "../../services/api";

const Login = () => {
    const aviso = useRef(null);
    const navegacao = useNavigate();
    const {isMobile} = useMobile();
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const margem = isMobile ? 0 : 5;

    useEffect(() => {
        autoLogin();
    }, []);

    const autoLogin = () => {
        setEmail('');
        setSenha('');
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            limparCache();
        }

        if (Token()) {
            navegacao('/sistema');
        }
    };

    const limparCache = () => {
        if ('caches' in window) {
            caches.keys().then((names) => {
                if (names.length > 0) {
                    names.forEach(name => {
                        caches.delete(name);
                    });
                    window.location.reload(true);
                }
            });

        }
    };

    const aoEnter = (e) => {
        if (e.key === 'Enter' && email && senha) {
            aoAutenticar(e);
        }
    };

    const aoAutenticar = async (e) => {
        e.preventDefault();
        try {
            if (!email || !senha) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o E-mail e a Senha para entrar!'};
            } else {
                new api().requisitar('post', 'seguranca/autenticacao', {email: email, senha: senha}).then((resposta) => {
                    if (resposta && resposta.Token) {
                        RegistrarToken(resposta.Token, resposta.RefreshToken);
                        navegacao('/sistema');
                    } else {
                        throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Ocorreu um erro na comunicação com a API'};
                    }
                }).catch((erro) => {
                    const msgErro = erro.mensagem ?? (erro.response.data.error_description ?? erro.response.data) ?? 'Ocorreu um erro não tratado';
                    aviso.current.show({severity: erro.tipo ?? 'error', summary: (!msgErro ? 'Erro' : 'Atenção'), detail: msgErro ?? 'Ocorreu um erro não tratado', life: 3000});
                });
            }
        } catch (erro) {
            if (!erro.mensagem) {
                if (erro.response && erro.response.status === 403 && erro.response.data.error_description) {
                    erro.mensagem = erro.response.data.error_description;
                    erro.titulo = 'Atenção!!';
                    erro.tipo = 'warn';
                } else {
                    erro.mensagem = erro.response.data.error_description ?? (erro.response?.data ?? 'Ocorreu um erro não tratado');
                }
            }

            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? 'Ocorreu um erro não tratado', life: 3000});
        }
    };

    return (<FundoLogin>
        <Toast ref={aviso}></Toast>
        <Card className={`p-align-center p-${margem}`} style={{maxWidth: 600, margin: 'auto'}}>
            <Image src={Logo} title={'EASYSIGN'} imageClassName='mb-5' alt={'EASYSIGN'} style={{width: '100%'}} imageStyle={{width: '100%', maxWidth: 500}}/>
            <div className="grid">
                <div className="field col-12 sm:12">
                    <span className={`p-float-label mt-5 mr-${margem} ml-${margem}`}>
                        <InputText placeholder={"Informe aqui seu e-mail"} className='w-full' id="username" autoComplete={'off'} value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={aoEnter} required autoFocus/>
                        <label htmlFor="username">e-mail</label>
                    </span>
                </div>
                <div className="field col-12 sm:col-12">
                    <span className={`p-float-label ml-${margem} mr-${margem} mt-1`}>
                        <InputText placeholder={"Informe aqui sua senha"} className='w-full' autoComplete={'off'} type="password" id="senha" maxLength={50} value={senha} onChange={(e) => setSenha(e.target.value)} onKeyDown={aoEnter} required/>
                        <label htmlFor="senha">senha</label>
                    </span>
                </div>
                <div className="field col-12 sm:col-12">
                    <Button className='primary' label='Entrar' onClick={aoAutenticar}/>
                </div>
                <div className="field col-12 sm:col-12">
                    <a href="https://wa.me/5511993505212?text=Esqueci%20minha%20senha%20do%20painel%20administrativo%20EasySign" style={{textDecoration: 'none'}}>Esqueci a minha senha</a>
                </div>
            </div>
        </Card>
    </FundoLogin>);
}

export default Login;